module.exports = __webpack_public_path__ + "images/help/icon-twr43-20a11f7e614b24dca721eb5d83d4d7ed.png";